module.exports = __webpack_public_path__ + "img/icon-lock-green.6659363a.svg";